import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';

/**
 * El header traceparent NO se inyecta manualmente aquí.
 *
 * El SDK de @microsoft/applicationinsights-web intercepta automáticamente
 * todos los XHR/fetch y agrega su propio traceparent internamente.
 * Si lo inyectáramos también aquí, los dos headers colisionarían:
 * el backend recibiría uno y AppInsights registraría el otro,
 * rompiendo la correlación en el Application Map (sin flechas entre nodos).
 *
 * La configuración que habilita esto en appinsights.js:
 *   enableCorsCorrelation: true
 *   enableRequestHeaderTracking: true
 *   disableFetchTracking: false
 */
export const getAxiosInstance = (
    appState: { token: string | null },
    onUnauthorized: () => void,
    wf = false,
    image = false
): AxiosInstance => {
    const axiosConfig: AxiosRequestConfig = {
        headers: {
            Authorization: appState.token ? `Bearer ${appState.token}` : '',
        },
        baseURL: `${process.env.REACT_APP_API_BASEURL}${wf ? process.env.REACT_APP_API_WF : process.env.REACT_APP_API_NORMAL}`,
    };

    if (image) {
        axiosConfig.headers = axiosConfig.headers || {};
        axiosConfig.headers['Content-Type'] = 'application/json';
        axiosConfig.headers['Accept'] = 'image/png';
        axiosConfig.responseType = 'arraybuffer';
    }

    const instance = axios.create(axiosConfig);

    /**
     * Interceptor de response: maneja errores 401 globalmente.
     */
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 401) {
                onUnauthorized();
            }
            return Promise.reject(error);
        }
    );

    return instance;
};
